import React, { useLayoutEffect, useRef } from 'react';

export const useMountedLayoutEffect = (
  effect: React.EffectCallback,
  deps?: React.DependencyList,
) => {
  const mounted = useRef(false);
  useLayoutEffect(() => {
    if (mounted.current) {
      return effect();
    }

    mounted.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
